import { useState, useEffect, useCallback, useRef } from 'react';
import { Keyboard } from '@capacitor/keyboard';
import { Device } from '@capacitor/device';

function useKeyboardAndroid() {
  const [isKeyboardVisible, setKeyboardVisible] = useState(false);
  const currentPlatformIsAndroid = useRef(false);

  const initListener = useCallback(async () => {
    const { platform } = await Device.getInfo();
    
    if (platform === 'android') {
      currentPlatformIsAndroid.current = true;
      Keyboard.addListener('keyboardWillShow', () => {
        setKeyboardVisible(true);
      });
      Keyboard.addListener('keyboardWillHide', () => {
        setKeyboardVisible(false);
      });
    }
  }, []);

  useEffect(() => {
    initListener();
    return () => {
      currentPlatformIsAndroid.current && Keyboard.removeAllListeners();
    };
  }, [initListener]);

  return isKeyboardVisible;
}

export default useKeyboardAndroid;
